import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "circle-k",
  "use": "circle-k-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"circle-k\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM6.93496 7.91227V4.73623H5.64928V11.5433H6.93496V9.50478L7.69607 8.69125L9.59046 11.5433H11.1192L8.54521 7.74626L11.0211 4.73623H9.44553L7.58481 7.06915L6.93496 7.91227Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol